module.exports = __webpack_public_path__ + "static/media/chrome.06c5ad2e.svg";


//////////////////
// WEBPACK FOOTER
// ../images/chrome.svg
// module id = 664
// module chunks = 0